import type { DriveAuthSession } from '../types';

// Must match the phrase the server requires — see api/account.ts
export const DELETE_CONFIRMATION = 'DELETE MY ACCOUNT';

export interface AccountDeletionResult {
  deleted: boolean;
  message: string;
  failedSteps?: { step: string; detail?: string }[];
}

export const accountService = {
  async deleteAccount(session: DriveAuthSession): Promise<AccountDeletionResult> {
    const response = await fetch('/api/account', {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${session.idToken || session.accessToken}`,
        'x-access-token': session.accessToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ confirm: DELETE_CONFIRMATION }),
    });

    const payload = await response.json().catch(() => ({}));

    // 207 means some data survived; surface that rather than reporting success.
    if (!response.ok && response.status !== 207) {
      throw new Error(payload?.error || 'Failed to delete account.');
    }

    return {
      deleted: Boolean(payload?.deleted),
      message: payload?.message || 'Account deletion completed.',
      failedSteps: payload?.failedSteps,
    };
  },
};
